'use client';

import React from 'react';

export const FormCrypto: React.FC = () => {
  return (
    <section className="component component--no-header">
      <div className="container">[placeholder]</div>
    </section>
  );
};
